import esMapping from "./elasticSearchMapping.json";
import { i18n } from "app/i18n/i18n.js";
import { firstItem } from "lib/utils";
import { parseDates } from "./parseDates";

export const filterToGRPJAPIUrl = (filter, pubLang) => {
  const toFromDates = parseDates(firstItem(filter.Date), firstItem(filter.DateTo));
  filter = { ...filter, ...toFromDates };

  if (filter.Language || pubLang.length) {
    filter.language = filter.Language || pubLang;
  }
  return {
    query: queryFieldJAPI(filter),
    filters: Object.entries(filter).filter(isFilterKey).map(valuesToArray).map(toGrpJAPIFormat).flat(),
  };
};

const isFilterKey = ([key, _values]) =>
  ![
    "SortAsc",
    "SortDesc",
    "sort",
    "includeSynopsis",
    "exact",
    "atleast",
    "exclude",
    "title",
    "titleExact",
    "titleAtleast",
    "titleExclude",
    "Date",
    "DateTo",
    "exclusions",
    "Language",
    "source",
    "es-index",
    "debug",
    "ads",
    "q",
    "Tab",
  ].includes(key);
const valuesToArray = ([key, values]) => (Array.isArray(values) ? [key, values] : [key, [values]]);
const toGrpJAPIFormat = ([key, values]) => values.filter(() => key).map((value) => ({ [parseToESKeys(key)]: value }));

export const sortFieldJAPI = (sort) => {
  if (!sort) return undefined;
  // eslint-disable-next-line no-unused-vars
  const [Field] = sort.split("_");
  return Field ? parseToESKeys(Field) : null;
};

export const sortOrderJAPI = (sort) => {
  if (!sort) return undefined;
  // eslint-disable-next-line no-unused-vars
  const [, Order] = sort.split("_");
  return Order === "Asc" ? "Ascending" : Order === "Desc" ? "Descending" : "";
};

// MP: this logic shouldn't be in the url query geneartor
export const excludeFieldJAPI = (filter) => {
  const excludeFilters = [];
  const lang = i18n.getLanguage() === "ja" ? "-JA" : "";
  (filter.exclusions || []).forEach((exclusion) => {
    switch (exclusion) {
      case "Models":
        excludeFilters.push({ [parseToESKeys("Periodicals" + lang)]: "Models" });
        break;
      case "Short Notes":
        excludeFilters.push({ [parseToESKeys("Periodicals" + lang)]: "Insights" });
        excludeFilters.push({ [parseToESKeys("Report Types" + lang)]: "Insights" });
        break;
      default:
        break;
    }
  });
  return excludeFilters;
};

const parseToESKeys = (key) => esMapping[key.toUpperCase()] || key; // JAPI accepts ES keys

// MP: needs rewriting
export const queryFieldJAPI = (filter) => {
  // Add title and string search to query
  let bucket = [];

  if (filter) {
    if (filter[""]) {
      const searchQuery = filter[""].filter((el) => el.trim()).map((el) => "(" + el + ")");
      if (searchQuery && searchQuery.length) bucket.push(searchQuery.join(" AND "));
    }
    if (filter["q"]) {
      const searchQuery = filter["q"].filter((el) => el.trim()).map((el) => "(" + el + ")");
      if (searchQuery && searchQuery.length) bucket.push(searchQuery.join(" AND "));
    }
    if (filter["title"]) {
      const searchQuery = filter["title"]
        .filter((el) => {
          return el.trim();
        })
        .map((el) => {
          return "title:(" + el + ")";
        });
      if (searchQuery && searchQuery.length) bucket.push(searchQuery.join(" AND "));
    }
    if (filter["exact"]) {
      const searchQuery = filter["exact"].filter((el) => el.trim()).map((el) => '\\"' + el + '\\"');
      if (searchQuery && searchQuery.length) bucket.push(searchQuery.join(" AND "));
    }
    if (filter["titleExact"]) {
      const searchQuery = filter["titleExact"].filter((el) => el.trim()).map((el) => 'title:\\"' + el + '\\"');
      if (searchQuery && searchQuery.length) bucket.push(searchQuery.join(" AND "));
    }
    if (filter["atleast"]) {
      const searchQuery = filter["atleast"].filter((el) => el.trim()).map((el) => el.split(" ").join(" OR "));
      if (searchQuery && searchQuery.length) bucket.push("(" + searchQuery.join(" OR ") + ")");
    }
    if (filter["titleAtleast"]) {
      const searchQuery = filter["titleAtleast"]
        .filter((el) => el.trim())
        .map((el) =>
          el
            .split(" ")
            .map((el) => "title:(" + el + ")")
            .join(" OR "),
        );
      if (searchQuery && searchQuery.length) bucket.push("(" + searchQuery.join(" OR ") + ")");
    }
    if (filter["exclude"]) {
      const searchQuery = filter["exclude"].filter((el) => el.trim()).map((el) => el.split(" ").join(" OR "));
      if (searchQuery && searchQuery.length) bucket.push("NOT (" + searchQuery.join(" OR ") + ")");
    }
    if (filter["titleExclude"]) {
      const searchQuery = filter["titleExclude"]
        .filter((el) => el.trim())
        .map((el) =>
          el
            .split(" ")
            .map((el) => "title:(" + el + ")")
            .join(" OR "),
        );
      if (searchQuery && searchQuery.length) bucket.push("NOT (" + searchQuery.join(" OR ") + ")");
    }
  }
  return bucket.join(" AND ");
};
